import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const configCard = css`
	border: 1px solid ${colors.border};
	border-radius: 4px;

	:not(:last-child) {
		margin-bottom: 15px;
	}

	.cardHeader {
		display: flex;
		justify-content: space-between;
		padding: 10px 16px;
		color: #495057;
	}

	.configCardTitle {
		display: flex;
		white-space: nowrap;
		overflow: hidden;
		.titleText {
			text-overflow: ellipsis;
		}
	}

	.expanded {
		border-bottom: 1px solid ${colors.border};
	}

	.collapseIcon {
		transition-duration: 500ms;
	}

	.collapseIconRotate {
		transform: rotate(-90deg);
		transition-duration: 500ms;
	}

	.tools {
		display: flex;
		align-items: center;
		white-space: nowrap;

		.badge {
			margin-left: 10px;
		}

		svg {
			margin-left: 10px;
		}
	}

	.overrideSwitch {
		color: ${colors.secondaryText};
	}

	.cardBody {
		padding: 16px;
		color: ${colors.mainText};
	}

	.parametersBlock {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;

		border-bottom: 1px solid ${colors.border};
		padding-bottom: 15px;
		margin-bottom: 15px;

		.parameters {
			display: flex;
			align-items: center;
			justify-content: space-between;

			span {
				margin-right: 10px;
			}

			input {
				width: 100px;
			}

			.info {
				margin-left: 10px;
			}
		}

		.enableSwitch {
			margin-right: 25px;
			display: flex;
		}
	}

	.rejoinder {
		padding-left: 37px;
		background-color: ${colors.background};
		border: 1px solid #ced4da;
		border-radius: 4px;
		position: relative;
	}

	.match-config {
		padding-left: 37px;
		background-color: ${colors.background};
		border: 1px solid #ced4da;
		border-radius: 4px;
		position: relative;
		align-items: center;
	}

	.match-expression {
		width: 100%;
	}

	.exact-match-boolean-parameters {
		display: flex;
	}

	.exact-match-parameters-ro {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.exact-match-boolean-parameters-ro {
		display: flex;
		justify-content: space-between;
	}

	.rejoinderHeader {
		font-size: 14px;
	}

	.match-expression-enabled {
		display: flex;
		justify-content: space-between;
	}

	.rejoinder-text {
		border: none;
		border-left: 1px solid #ced4da;
		border-top-left-radius: unset;
		border-bottom-left-radius: unset;
		font-size: 14px;

		background-color: white !important;
	}

	.addRejoinderButton {
		font-size: 14px;
		border: none;

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}

		svg {
			margin-right: 5px;
		}
	}

	.deleteRejoinderIcon {
		position: absolute;
		top: 4px;
		right: 4px;
		color: #ced4da;

		:hover {
			color: ${colors.hoverText};
		}
	}

	.editabilityRadio {
		margin-bottom: 10px;
	}
`;

export const validationsBlock = css`
	border: 1px solid ${colors.border};
	border-radius: 4px;

	.validationsHeader {
		display: flex;
		justify-content: space-between;
		padding: 10px 16px;
		color: #495057;
	}

	.collapseIcon {
		transition-duration: 500ms;
	}

	.collapseIconRotate {
		transform: rotate(-90deg);
		transition-duration: 500ms;
	}

	.tools {
		display: flex;
		align-items: center;

		svg {
			margin-left: 10px;
		}
	}

	.validationsBody {
		padding: 16px;
		color: ${colors.mainText};
	}
`;
